import React, { useContext, useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';

import { EstadosBrasil } from '../../../main/constant/UfConstant';
import MessageConstant from '../../../main/constant/MessageConstant';

import { Button, Card, Col, Container, Form, Modal, Row, Table } from 'react-bootstrap';
import { AddEspecialidadeModalPageStyled, AddProfessionalModalPageStyled, AddProfessionalPageStyled } from './AddProfessionalPageStyled';

import AlertComponent from '../../component/alert/AlertComponent';
import ContainerSideBarComponent from '../../component/container/ContainerSidebarComponent';

import { TfiSave } from 'react-icons/tfi';
import { FaArrowLeft, FaPlus, FaTimes, FaTrashAlt } from 'react-icons/fa';
import { PiIdentificationCard } from 'react-icons/pi';
import { IoLocationOutline, IoPersonCircleOutline } from 'react-icons/io5';

import { AddProfessional, EditProfessional, ListProfessional, PropsAddProfessional } from './AddProfessionalPageType';

import { maskUtils } from '../../../main/helper/maskHelper';
import { FormatDate } from '../../../main/helper/dateFormatter';
import { AuthContext } from '../../../data/context/AuthContext';
import { ProfilesConstant } from '../../../main/constant/ProfilesConstant';

/**
 * AddProfessionalPage
 * @param add
 * @param comeBack
 * @param professional
 * @param edit
 * @constructor
 */
const AddProfessionalPage: React.FC<PropsAddProfessional> = ({
  add,
  comeBack,
  professional,
  edit,
  professionalSpecialties,
  specialtiesList,
  specialtiesPagination,
  clinicSpecialtiesFilter,
  getclinicSpecialties,
  addSpecialties,
  removeSpecialties,
  getProfessional,
  addSpecialtiesClinic,
  getAddress,
  address,
}: PropsAddProfessional) => {
  /**
   * Perfil de acesso
   */
  const PROFILE_ADMIN = ProfilesConstant.admin;
  const PROFILE_DENTISTA = ProfilesConstant.dentist;
  const PROFILE_RECEPCIONISTA = ProfilesConstant.receptionist;

  const ROLE_ADMIN = PROFILE_ADMIN;

  /**
   * mostra modal
   */
  const [show, setShow] = useState(false);

  /**
   * usuario logado
   */
  const { loggedUserData } = useContext(AuthContext);
  const userRoles = loggedUserData?.roles || [];
  const roleIsAdmin = userRoles.includes(ROLE_ADMIN);
  const disablePerfil = (): boolean => {
    const userLogin = loggedUserData?.login;
    const userEmail = getValues('email');

    if ((userLogin !== undefined || userLogin !== null) && userEmail !== undefined) {
      if (roleIsAdmin && userLogin!.toLowerCase() === userEmail.toLowerCase()) {
        return false;
      }
    }

    return roleIsAdmin;
  };

  const disableEmail = (): boolean => {
    const userLogin = loggedUserData?.login;
    const userEmail = getValues('email');

    if ((userLogin !== undefined || userLogin !== null) && userEmail !== undefined) {
      if (roleIsAdmin && userLogin!.toLowerCase() === userEmail.toLowerCase()) {
        return false;
      }
    }

    return roleIsAdmin;
  };

  /**
   * handleClose - fecha modal
   */
  const handleClose = async () => {
    await getProfessional(getValues('id'));
    setShow(false);
  };

  /**
   * handleShow - abre modal
   */
  const handleShow = () => setShow(true);

  /** useForm */
  const {
    register,
    getValues,
    setValue,
    control,
    handleSubmit,
    formState: { errors },
    watch,
  } = useForm<ListProfessional>();

  /**
   * handleAdd - Cria professional
   */
  const handleAdd = async () => {
    const model: AddProfessional = {
      status: 'A',
      name: getValues('name') ?? '',
      document: getValues('document') ?? '',
      cellPhone: getValues('cellPhone') ?? '',
      email: getValues('email') ?? '',
      profileDescription: getValues('profileDescription') ?? '',
      appointmentTime: getValues('appointmentTime') ?? 0,
      birthDate: getValues('birthDate') ?? '',
      boardRegistration: getValues('boardRegistration') ?? 0,
      prefix: getValues('prefix') ?? '',
      document_RG: getValues('document_RG') ?? '',
      stateCouncil: getValues('stateCouncil') ?? '',
      gender: getValues('gender') ?? '',
      address_PostalCode: getValues('address_PostalCode') ?? '',
      address_Street: getValues('address_Street') ?? '',
      address_Number: getValues('address_Number') ?? '',
      address_Complement: getValues('address_Complement') ?? '',
      address_Neighborhood: getValues('address_Neighborhood') ?? '',
      address_City: getValues('address_City') ?? '',
      address_State: getValues('address_State') ?? '',
      specialties: getValues('specialties') ?? [],
    };

    await add(model);
  };

  /**
   * handleEdit - Edita professional
   */
  const handleEdit = async () => {
    const model: EditProfessional = {
      id: getValues('id') ?? '',
      status: getValues('status') ?? '',
      name: getValues('name') ?? '',
      document: getValues('document') ?? '',
      cellPhone: getValues('cellPhone') ?? '',
      email: getValues('email') ?? '',
      profileDescription: !disablePerfil() ? PROFILE_ADMIN : getValues('profileDescription'),
      appointmentTime: getValues('appointmentTime') ?? 0,
      birthDate: getValues('birthDate') ?? '',
      boardRegistration: getValues('boardRegistration') ?? '',
      prefix: getValues('prefix') ?? '',
      document_RG: getValues('document_RG') ?? '',
      stateCouncil: getValues('stateCouncil') ?? '',
      gender: getValues('gender') ?? '',
      address_PostalCode: getValues('address_PostalCode') ?? '',
      address_Street: getValues('address_Street') ?? '',
      address_Number: getValues('address_Number') ?? '',
      address_Complement: getValues('address_Complement') ?? '',
      address_Neighborhood: getValues('address_Neighborhood') ?? '',
      address_City: getValues('address_City') ?? '',
      address_State: getValues('address_State') ?? '',
      specialties: getValues('specialties') ?? [],
    };

    await edit(model);
  };

  /**
   * setModel - Preenche model
   * @param model
   */
  const setModel = (model: any) => {
    if (model !== null) {
      setValue('id', model.id);
      setValue('status', model.status);
      setValue('name', model.name);
      setValue('document', model.document ? maskUtils.cpf(model.document.trimEnd()) : '');
      setValue('cellPhone', model.cellPhone ? maskUtils.celular(model.cellPhone.trimEnd()) : '');
      setValue('email', model.email);
      setValue('profileDescription', model.profileDescription);
      setValue('appointmentTime', model.appointmentTime);
      setValue('birthDate', FormatDate.formatToDateOnly(model.birthDate));
      setValue('boardRegistration', model.boardRegistration);
      setValue('prefix', model.prefix);
      setValue('document_RG', model.document_RG ? maskUtils.rg(model.document_RG.trimEnd()) : '');
      setValue('stateCouncil', model.stateCouncil);
      setValue('gender', model.gender);
      setValue('address_PostalCode', model.address_PostalCode ? maskUtils.cep(model.address_PostalCode.trimEnd()) : '');
      setValue('address_Street', model.address_Street);
      setValue('address_Number', model.address_Number);
      setValue('address_Complement', model.address_Complement);
      setValue('address_Neighborhood', model.address_Neighborhood);
      setValue('address_City', model.address_City);
      setValue('address_State', model.address_State);
      setValue('specialties', model.specialties);
      setValue('clinicId', model.clinicId);
      setValue('userId', model.userId);
    }
  };

  /**
   * handleSubmitValidation
   */
  const handleSubmitValidation = async () => {
    professional === null ? await handleAdd() : await handleEdit();
  };

  /**
   * inicio
   */
  useEffect(() => {
    setModel(professional);
  }, [professional]);

  /**
   * Termos de busca do filtro de especialidades
   */
  const [searchTerm, setSearchTerm] = useState('');

  /**
   * Busca pelo nome filtrado com mais de 3 caracteres e se não tiver valor ele volta ao valor original
   */
  useEffect(() => {
    const handler = setTimeout(() => {
      if (searchTerm.length > 3) {
        clinicSpecialtiesFilter(searchTerm);
      } else if (searchTerm.length === 0) {
        getclinicSpecialties();
      }
    }, 2000);

    return () => clearTimeout(handler);
  }, [searchTerm]);

  const [nomeEspecialidade, setNomeEspecialidade] = useState('');
  const handleAddEspecialidade = async () => {
    await addSpecialtiesClinic({ description: nomeEspecialidade });
  };

  /**
   * handleCepChange - busca o endereco pelo cep
   * @param cep
   */
  const handleCepChange = async (cep: string) => {
    const cepFormatado = maskUtils.cep(cep);
    if (cepFormatado.length === 9) {
      await getAddress(cepFormatado);
    }
  };

  /**
   * inicio
   */
  useEffect(() => {
    if (address !== null) {
      setValue('address_Street', address.street);
      setValue('address_Neighborhood', address.neighborhood);
      setValue('address_City', address.city);
      setValue('address_State', address.state);
    }
  }, [address]);

  const profissionalWatch = watch();

  return (
    <ContainerSideBarComponent>
      <AlertComponent />
      <AddProfessionalPageStyled>
        <Container fluid className="title-page text-center mb-4">
          {professional && <h3>{`Profissional - ${professional.name}`}</h3>}
          {professional === null && <h3>Novo Profissional</h3>}
        </Container>

        <Container fluid>
          <Card style={{ marginBottom: '40px' }}>
            <Card.Body>
              <Container fluid>
                <Form onSubmit={handleSubmit(handleSubmitValidation)}>
                  <input type="hidden" id="id" {...register('id')} />
                  <input type="hidden" id="status" {...register('status')} />
                  <input type="hidden" id="clinicId" {...register('clinicId')} />
                  <input type="hidden" id="userId" {...register('userId')} />

                  <div className="container-field mb-4">
                    <Row className="row-field mb-3">
                      <Col className="d-flex justify-content-end">
                        <Button size="sm" type="submit" className="me-2">
                          <TfiSave width={30} style={{ paddingRight: '5px' }} />
                          Salvar
                        </Button>
                        <Button size="sm" variant="outline-primary" style={{ float: 'right', marginRight: '5px' }} onClick={comeBack}>
                          <FaArrowLeft width={30} style={{ paddingRight: '5px' }} />
                          Voltar
                        </Button>
                      </Col>
                    </Row>
                    <div className="title">
                      <PiIdentificationCard />
                      <h6>Dados Pessoais</h6>
                    </div>
                    <Row className="row-field">
                      <Col sm={12} md={6} lg={4} className="mb-3">
                        <Form.Label>Prefixo</Form.Label>
                        <Form.Control placeholder="Prefixo" {...register('prefix')} />
                        {errors.prefix && <span className="text-danger">{errors.prefix.message}</span>}
                      </Col>
                      <Col sm={12} md={6} lg={4} className="mb-3">
                        <Form.Label>Nome</Form.Label>
                        <Form.Control placeholder="Nome" {...register('name', { required: MessageConstant.validacao.campoObrigatorio })} />
                        {errors.name && <span className="text-danger">{errors.name.message}</span>}
                      </Col>
                    </Row>
                    <Row className="row-field">
                      <Col sm={12} md={6} lg={4} className="mb-3">
                        <Form.Label>Perfil</Form.Label>
                        {!disablePerfil() && (
                          <>
                            <Controller
                              control={control}
                              disabled={!disablePerfil()}
                              name="profileDescription"
                              render={({ field }) => (
                                <Form.Select {...field}>
                                  <option value={PROFILE_ADMIN}>Gestor da Clinica</option>
                                </Form.Select>
                              )}
                            />
                          </>
                        )}

                        {disablePerfil() && (
                          <>
                            <Controller
                              control={control}
                              disabled={!disablePerfil()}
                              name="profileDescription"
                              rules={{
                                required: MessageConstant.validacao.campoObrigatorio,
                                validate: (value) => value !== '' || MessageConstant.validacao.campoObrigatorio,
                              }}
                              render={({ field }) => (
                                <Form.Select {...field}>
                                  <option value="">Selecione</option>
                                  <option value={PROFILE_DENTISTA}>Dentista</option>
                                  <option value={PROFILE_RECEPCIONISTA}>Recepcionista</option>
                                </Form.Select>
                              )}
                            />
                            {errors.profileDescription && <span className="text-danger">{errors.profileDescription.message}</span>}
                          </>
                        )}
                      </Col>

                      <Col sm={12} md={6} lg={4} className="mb-3">
                        <Form.Label>E-mail</Form.Label>
                        <Form.Control
                          disabled={!disableEmail()}
                          placeholder="E-mail"
                          {...register('email', { required: MessageConstant.validacao.campoObrigatorio })}
                        />
                        {errors.email && <span className="text-danger">{errors.email.message}</span>}
                      </Col>
                      <Col sm={12} md={6} lg={4} className="mb-3">
                        <Form.Label>Celular</Form.Label>
                        <Controller
                          control={control}
                          name="cellPhone"
                          rules={{ required: MessageConstant.validacao.campoObrigatorio }}
                          render={({ field }) => (
                            <Form.Control {...field} placeholder="Celular" onChange={(e) => field.onChange(maskUtils.celular(e.target.value))} />
                          )}
                        />
                        {errors.cellPhone && <span className="text-danger">{errors.cellPhone.message}</span>}
                      </Col>
                    </Row>
                    <Row className="row-field">
                      <Col>
                        <Form.Label>CPF</Form.Label>
                        <Controller
                          control={control}
                          name="document"
                          render={({ field }) => <Form.Control {...field} placeholder="CPF" onChange={(e) => field.onChange(maskUtils.cpf(e.target.value))} />}
                        />
                        {errors.document && <span className="text-danger">{errors.document.message}</span>}
                      </Col>
                      <Col>
                        <Form.Label>RG</Form.Label>
                        <Controller
                          control={control}
                          name="document_RG"
                          render={({ field }) => <Form.Control {...field} placeholder="RG" onChange={(e) => field.onChange(maskUtils.rg(e.target.value))} />}
                        />
                        {errors.document_RG && <span className="text-danger">{errors.document_RG.message}</span>}
                      </Col>
                      <Col sm={2}>
                        <Form.Label>Data nascimento</Form.Label>
                        <Form.Control
                          type="date"
                          min="1900-01-01"
                          max="2100-12-31"
                          placeholder="Data nascimento"
                          {...register('birthDate', { required: MessageConstant.validacao.campoObrigatorio })}
                        />
                        {errors.birthDate && <span className="text-danger">{errors.birthDate.message}</span>}
                      </Col>
                      <Col>
                        <Form.Label>Sexo</Form.Label>
                        <Controller
                          name="gender"
                          control={control}
                          render={({ field }) => (
                            <Form.Select {...field}>
                              <option value="F">Feminino</option>
                              <option value="M">Masculino</option>
                            </Form.Select>
                          )}
                        />
                      </Col>
                    </Row>
                  </div>
                  {professional !== null && (
                    <div className="container-field">
                      <div className="title">
                        <IoLocationOutline />
                        <h6>Especialidades</h6>
                      </div>
                      <div>
                        <Row className="row-field">
                          <Col>
                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                              {professionalSpecialties !== null &&
                                professionalSpecialties.map((item: any, index: number) => {
                                  return (
                                    <div key={index} style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                      <Button
                                        variant="light"
                                        size="sm"
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          gap: '5px',
                                        }}
                                        onClick={() => removeSpecialties(item)}>
                                        <span>{item.description}</span>
                                        <FaTimes />
                                      </Button>
                                    </div>
                                  );
                                })}
                            </div>
                          </Col>
                        </Row>
                        <Row className="row-field">
                          <Col>
                            <Button size="sm" variant="outline-primary" onClick={handleShow}>
                              Adicionar especialidades
                            </Button>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  )}

                  <div className="container-field">
                    <div className="title">
                      <IoLocationOutline />
                      <h6>Endereço</h6>
                    </div>
                    <div>
                      <Row className="row-field">
                        <Col sm={3}>
                          <Form.Label>Cep</Form.Label>
                          <Controller
                            control={control}
                            name="address_PostalCode"
                            // rules={{ required: MessageConstant.validacao.campoObrigatorio }}
                            render={({ field }) => (
                              <Form.Control
                                {...field}
                                placeholder="Cep"
                                onChange={(e) => {
                                  const cepComMascara = maskUtils.cep(e.target.value);
                                  field.onChange(cepComMascara);
                                  handleCepChange(cepComMascara);
                                }}
                              />
                            )}
                          />
                          {errors.address_PostalCode && <span className="text-danger">{errors.address_PostalCode.message}</span>}
                        </Col>
                        <Col>
                          <Form.Label>Endereço</Form.Label>
                          <Form.Control placeholder="Endereço" {...register('address_Street')} />
                        </Col>
                      </Row>
                      <Row className="row-field">
                        <Col>
                          <Form.Label>Número</Form.Label>
                          <Form.Control placeholder="Número" {...register('address_Number')} />
                          {errors.address_Number && <span className="text-danger">{errors.address_Number.message}</span>}
                        </Col>
                        <Col>
                          <Form.Label>Complemento</Form.Label>
                          <Form.Control placeholder="Complemento" {...register('address_Complement')} />
                        </Col>
                        <Col>
                          <Form.Label>Bairro</Form.Label>
                          <Form.Control placeholder="Bairro" {...register('address_Neighborhood')} />
                          {errors.address_Neighborhood && <span className="text-danger">{errors.address_Neighborhood.message}</span>}
                        </Col>
                        <Col>
                          <Form.Label>Cidade</Form.Label>
                          <Form.Control placeholder="Cidade" {...register('address_City')} />
                          {errors.address_City && <span className="text-danger">{errors.address_City.message}</span>}
                        </Col>
                        <Col>
                          <Form.Label>Estado</Form.Label>
                          <Form.Select aria-label="UF" {...register('address_State')}>
                            <option value="">Selecione a UF</option>
                            {EstadosBrasil.map((item) => {
                              return (
                                <option key={item.sigla} value={item.sigla}>
                                  {item.nome}
                                </option>
                              );
                            })}
                          </Form.Select>
                          {errors.address_State && <span className="text-danger">{errors.address_State.message}</span>}
                        </Col>
                      </Row>
                    </div>
                  </div>
                  {profissionalWatch.profileDescription === 'professional_intelidente_light' && (
                    <div className="container-field">
                      <div className="title">
                        <IoPersonCircleOutline />
                        <h6>Dados legais</h6>
                      </div>
                      <div>
                        <Row className="row-field">
                          <Col sm={3}>
                            <Form.Label>Registro do conselho</Form.Label>
                            <Form.Control
                              placeholder="Registro do conselho"
                              {...register('boardRegistration', { required: MessageConstant.validacao.campoObrigatorio })}
                            />
                            {errors.boardRegistration && <span className="text-danger">{errors.boardRegistration.message}</span>}
                          </Col>
                          <Col sm={3}>
                            <Form.Label>Estado do conselho</Form.Label>
                            <Form.Select aria-label="UF">
                              <option value="">Selecione a UF</option>
                              {EstadosBrasil.map((item) => {
                                return (
                                  <option key={item.sigla} value={item.sigla}>
                                    {item.nome}
                                  </option>
                                );
                              })}
                            </Form.Select>
                            {errors.stateCouncil && <span className="text-danger">{errors.stateCouncil.message}</span>}
                          </Col>
                        </Row>
                      </div>
                    </div>
                  )}
                </Form>
              </Container>
            </Card.Body>
          </Card>
        </Container>
        <Modal show={show} onHide={handleClose} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Especialidades</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <AddProfessionalModalPageStyled>
              <Container fluid className="table-especialidade-page">
                <Card>
                  <Card.Body>
                    <Row className="row-field-filter-table">
                      <Col>
                        <Form.Label>Filtro:</Form.Label>
                        <Form.Control type="text" placeholder="Pesquise uma especialidade pelo nome" onChange={(e) => setSearchTerm(e.target.value)} />
                      </Col>
                    </Row>

                    <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
                      <Table striped={false} bordered={false} borderless={false} hover size="sm">
                        <thead>
                          <tr>
                            <th>Descrição</th>
                            <th>Ações</th>
                          </tr>
                        </thead>
                        <tbody>
                          {specialtiesList.map((item: any) => {
                            return (
                              <tr key={item.id}>
                                <td>{item.description}</td>
                                <td>
                                  <Row className="">
                                    <Col className="table-btn">
                                      <Button size="sm" variant="outline-primary" style={{ float: 'right' }} onClick={() => addSpecialties(item)}>
                                        <span>Adicionar</span>
                                      </Button>
                                    </Col>
                                  </Row>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </Table>
                    </div>
                  </Card.Body>
                </Card>
              </Container>
            </AddProfessionalModalPageStyled>

            <AddEspecialidadeModalPageStyled>
              <Container fluid style={{ paddingTop: '5%' }}>
                <Card>
                  <Card.Body>
                    <Row className="row-field-filter">
                      <Col xs={8}>
                        <Form.Label>Nome especialidade</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Digite uma Especialidade para adicionar"
                          onChange={(e) => setNomeEspecialidade(e.target.value)}
                        />
                      </Col>
                      <Col xs={4} className="filter-btn">
                        <Button size="sm" onClick={handleAddEspecialidade}>
                          <FaPlus />
                          <span>Adicionar Especialidade</span>
                        </Button>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              </Container>
            </AddEspecialidadeModalPageStyled>
          </Modal.Body>
          <Modal.Footer>
            <Button size="sm" variant="secondary" onClick={handleClose}>
              Fechar
            </Button>
          </Modal.Footer>
        </Modal>
      </AddProfessionalPageStyled>
    </ContainerSideBarComponent>
  );
};

export default AddProfessionalPage;
